// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedOption1 {
  color: black;
  transform: scale(1.05);
  margin: 1% 5%;
  cursor: pointer;

  font-weight: 500;
}

.notSelected1 {
  margin: 1% 5%;
  color: grey;
  cursor: pointer;
}

.report-user {
  display: inline-block;

  background: none;
  border: none;

  color: black;

  display: inline-block;
}

.report-user:hover {
  display: inline-block;

  background-color: grey;
}
.container-user {
  overflow: hidden;
  transition: width 0.3s ease;
  width: 30%;
  display: inline-block;
  height: 98vh;
  background-color: #F5F5F5;
  border-radius: 20px 0px 0px 20px ;
}
.collapsed-user {
  width: 5%;
}

.content {
  height: 100%;
  background-color: #f5f5f5;
  width: 100%;
  text-align: center;
  font-weight: 700;
  display: flex;
  flex-direction: row;
}

.usermanagestyle {
  writing-mode: vertical-lr;
  text-orientation: upright;
}
.arrow-right {
  font-size: 20px;
  width: 30px;
}
.userheader {
  font-family: Merriweather Sans;
  font-weight: bold;
  margin: 20px;
}

.outerdiv-usernav {
  flex-direction: row;
}
.innerdiv-usernav {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  width: 100%;
  margin: auto;
}
`, "",{"version":3,"sources":["webpack://./src/components/modules/userManagement/UserManagementNav.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb,eAAe;;EAEf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,qBAAqB;;EAErB,gBAAgB;EAChB,YAAY;;EAEZ,YAAY;;EAEZ,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;;EAErB,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,2BAA2B;EAC3B,UAAU;EACV,qBAAqB;EACrB,YAAY;EACZ,yBAAyB;EACzB,iCAAiC;AACnC;AACA;EACE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd","sourcesContent":[".selectedOption1 {\n  color: black;\n  transform: scale(1.05);\n  margin: 1% 5%;\n  cursor: pointer;\n\n  font-weight: 500;\n}\n\n.notSelected1 {\n  margin: 1% 5%;\n  color: grey;\n  cursor: pointer;\n}\n\n.report-user {\n  display: inline-block;\n\n  background: none;\n  border: none;\n\n  color: black;\n\n  display: inline-block;\n}\n\n.report-user:hover {\n  display: inline-block;\n\n  background-color: grey;\n}\n.container-user {\n  overflow: hidden;\n  transition: width 0.3s ease;\n  width: 30%;\n  display: inline-block;\n  height: 98vh;\n  background-color: #F5F5F5;\n  border-radius: 20px 0px 0px 20px ;\n}\n.collapsed-user {\n  width: 5%;\n}\n\n.content {\n  height: 100%;\n  background-color: #f5f5f5;\n  width: 100%;\n  text-align: center;\n  font-weight: 700;\n  display: flex;\n  flex-direction: row;\n}\n\n.usermanagestyle {\n  writing-mode: vertical-lr;\n  text-orientation: upright;\n}\n.arrow-right {\n  font-size: 20px;\n  width: 30px;\n}\n.userheader {\n  font-family: Merriweather Sans;\n  font-weight: bold;\n  margin: 20px;\n}\n\n.outerdiv-usernav {\n  flex-direction: row;\n}\n.innerdiv-usernav {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n  width: 100%;\n  margin: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
